/* Polsk katalog for locale-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'adv.sales.productsShowMore': 'Pokaż więcej',
  'adv.sales.productsNote': 'Kwota w sekcji „Największy obrót” to zafakturowana sprzedaż według produktu w wybranym roku. Wzrost i spadek pokazują procentową zmianę obrotu tego samego produktu względem poprzedniego roku. Produkty bez porównywalnych danych z poprzedniego roku nie są pokazywane we wzroście i spadku.',
  'adv.sales.productsPage': 'Strona {page} z {pages}',
  'adv.sales.productsPrevious': 'Poprzednia strona dla {label}',
  'adv.sales.productsNext': 'Następna strona dla {label}',
  'adv.sales.scn.adjust.priceUp': 'Podwyżka cen',
  'adv.sales.scn.adjust.volumeDown': 'Spadek wolumenu sprzedaży',
  'sale.doc.invoice': 'Nowa faktura',
  'sale.doc.quote': 'Nowa oferta',
  'sale.doc.orderConfirmation': 'Nowe potwierdzenie zamówienia',
  'sale.doc.creditNote': 'Nowa faktura korygująca',
  'sale.doc.other': 'Inna sprzedaż',
  'sale.howToCreate': 'Jak chcesz utworzyć {document}?',
  'sale.docIndefinite.invoice': 'fakturę',
  'sale.docIndefinite.quote': 'ofertę',
  'sale.docIndefinite.orderConfirmation': 'potwierdzenie zamówienia',
  'sale.docIndefinite.creditNote': 'fakturę korygującą',
  'sale.docIndefinite.other': 'inną sprzedaż',
  'sale.credit.title': 'Korekta',
  'sale.credit.help': 'Faktura korygująca wycofuje sprzedaż. Kwoty wpisuje się jako dodatnie, jak na fakturze — Plumme odwraca znak przy księgowaniu, więc przychód ze sprzedaży i VAT należny zostają zmniejszone, a należność od klienta uznana.',
  'sale.credit.reason': 'Przyczyna korekty',
  'sale.credit.reasonHint': 'Wymagane. Uzasadnienie musi pokazywać, co faktycznie się wydarzyło, a nie tylko kwotę.',
  'sale.credit.reasonPh': 'Zwrot towaru, obniżka ceny, błędne fakturowanie ...',
  'sale.credit.link': 'Powiąż z fakturą',
  'sale.credit.linkHint': 'Opcjonalne. Po powiązaniu numer faktury zostanie pobrany automatycznie, a faktura korygująca zostanie rozliczona z kwotą pozostałą do zapłaty na fakturze.',
  'sale.credit.linkNone': 'Bez powiązania – wolna nadpłata',
  'sale.credit.linkSearchPh': 'Szukaj po numerze faktury, kliencie lub kwocie ...',
  'sale.credit.linkNoMatches': 'Brak faktur pasujących do wyszukiwania',
  'sale.credit.linkShowMore': 'Pokaż więcej faktur',
  'sale.credit.invoiceOption': 'Faktura {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Wybrano z faktury',
  'sale.credit.noNumber': 'Bez numeru',
  'sale.credit.reference': 'Dotyczy (pierwotna sprzedaż)',
  'sale.credit.referenceHint': 'Wymagane bez powiązania z fakturą. Podaj numer faktury, umowę, okres lub system, w którym była sprzedaż.',
  'sale.credit.referencePh': 'Np. faktura 1042 lub „umowa 2025-04”',
  'sale.credit.linkedTo': 'Koryguje fakturę {document}',
  'sale.credit.offsetBadge': 'Rozliczane automatycznie',
  'sale.credit.freeHint': 'Bez powiązania kwota pozostaje jako nadpłata klienta. Możesz ją rozliczyć z fakturą lub zwrócić z listy faktur.',
  'sale.credit.date': 'Data faktury korygującej',
  'sale.credit.numberLabel': 'Nr faktury korygującej:',
  'sale.credit.amount': 'Kwota do zwrotu',
  'sale.credit.previewNote': 'Kwota została skorygowana. Zostanie rozliczona z należnościami lub zwrócona.',
  'sale.credit.previewReason': 'Przyczyna:',
  'sale.credit.previewReference': 'Dotyczy:',
  'sale.credit.set': 'Podaj szczegóły',
  'sale.credit.edit': 'Zmień',
  'sale.credit.missing': 'Przed utworzeniem faktury korygującej trzeba podać przyczynę i odniesienie do pierwotnej sprzedaży.',
  'sale.credit.noReference': 'Nie podano odniesienia',
  'sale.credit.freeBadge': 'Wolna nadpłata',
  'sale.credit.needReason': 'Najpierw wpisz przyczynę korekty',
  'sale.credit.needReference': 'Powiąż fakturę lub wskaż pierwotną sprzedaż, której dotyczy faktura korygująca',
  'sale.credit.needDetails': 'Najpierw podaj przyczynę i powiąż fakturę lub wskaż pierwotną sprzedaż',
  'sale.credit.create': 'Utwórz fakturę korygującą',
  'sale.det.period': 'Okres',
  'sale.det.subscriptionFrom': 'Abonament od',
  'sale.det.subscriptionTo': 'Abonament do',
  'sale.det.rentFrom': 'Najem od',
  'sale.det.rentTo': 'Najem do',
  'sale.lines.descShortPh': 'Np. godzina konsultingu lub abonament',
  'sale.from': 'Od',
  'sale.to': 'Do',
  'sale.use': 'Użyj',
  'sale.swap': 'Zamień',
  'sale.show': 'Pokaż',
  'sale.edit': 'Edytuj',
  'sale.download': 'Pobierz',
  'sale.send': 'Wyślij',
  'sale.add': 'Dodaj',
  'sale.save': 'Zapisz',
  'sale.saveChanges': 'Zapisz zmiany',
  'sale.thisSale': 'tę sprzedaż',
  'sale.step.kunde': 'Klient',
  'sale.step.bilag': 'Dokument',
  'sale.step.detaljer': 'Szczegóły',
  'sale.step.linjer': 'Pozycje',
  'sale.step.forhandsvisning': 'Podgląd',
  'sale.title': 'Sprzedaż / Faktura / Oferta',
  'sale.titleHelp': 'Zarejestruj sprzedaż, utwórz fakturę, ofertę lub potwierdzenie zamówienia',
  'sale.docTypeHelpTitle': 'Typ dokumentu',
  'sale.docTypeHelp': 'Wybierz rodzaj tworzonego dokumentu sprzedaży. Faktura to żądanie zapłaty od klienta. Oferta to niewiążąca propozycja cenowa. Potwierdzenie zamówienia potwierdza uzgodnione zamówienie. „Inna sprzedaż” służy do sprzedaży poza systemem, dla której przesyłasz dowód księgowy jako dokumentację.',
  'sale.stepsHelpTitle': 'Kroki sprzedaży',
  'sale.stepsHelp': 'Sprzedaż składa się z czterech kroków: Klient, Szczegóły, Pozycje i Podgląd (dla „Innej sprzedaży”: Dokument, Szczegóły, Pozycje i Podgląd). Dotknij kroku, aby do niego przejść. Krok jest oznaczony, jeśli czegoś brakuje przed utworzeniem dokumentu.',
  'sale.viewHelpTitle': 'Zmień widok',
  'sale.viewHelpToOnePage': 'Przełącza z procesu krok po kroku na jedną stronę, na której wszystkie pola są widoczne jednocześnie obok podglądu na żywo. Szybciej, gdy znasz już formularz.',
  'sale.viewHelpToSteps': 'Przełącza z jednej strony na spokojny proces krok po kroku, w którym wypełniasz jedną rzecz naraz — klienta, szczegóły, pozycje i podgląd. Dobre, gdy chcesz mieć wskazówki po drodze.',
  'sale.toOnePage': 'Przełącz na wszystko na jednej stronie',
  'sale.toSteps': 'Przełącz na krok po kroku',
  'sale.stepByStep': 'Krok po kroku',
  'sale.previewHelpTitle': 'Podgląd',
  'sale.previewHelp': 'Tutaj widzisz, jak gotowy dokument będzie wyglądał dla klienta — z nadawcą, danymi klienta, pozycjami i sumą. Aktualizuje się podczas wypełniania, więc możesz wszystko sprawdzić przed utworzeniem lub wysłaniem.',
  'sale.previewToggleHelp': 'Pokazuje lub ukrywa podgląd na żywo obok formularza. Ukryj go, jeśli chcesz mieć więcej miejsca na pola.',
  'sale.previewHide': 'Ukryj podgląd',
  'sale.previewShow': 'Pokaż podgląd',
  'sale.previewHeading': 'Tak wygląda dokument',
  'sale.backToVouchers': 'Wróć do transakcji',
  'sale.resetTitle': 'Wyczyść formularz i zacznij od nowa',
  'sale.reset': 'Wyczyść',
  'sale.resetDone': 'Formularz został wyczyszczony',
  'sale.back': 'Wstecz',
  'sale.next': 'Dalej',
  'sale.draftSaved': 'Szkic zapisany',
  'sale.draftSavedHelp': 'Szkic jest na liście faktur w obecnej postaci. Jeśli coś zmienisz, możesz zapisać ponownie — zaktualizuje to ten sam szkic.',
  'sale.saveDraft': 'Zapisz szkic',
  'sale.saveDraftHelpTitle': 'Zapisz szkic',
  'sale.saveDraftHelp': 'Zapisuje sprzedaż jako szkic na liście faktur bez wysyłania ani tworzenia. Możesz później kontynuować od miejsca, w którym skończyłeś.',
  'sale.saveDraftHelpLong': 'Zapisuje sprzedaż jako szkic na liście faktur bez wysyłania ani tworzenia. Możesz bezpiecznie opuścić stronę i później kontynuować od miejsca, w którym skończyłeś.',
  'sale.saveDraftHelpShort': 'Zapisuje sprzedaż jako szkic na liście faktur bez wysyłania ani tworzenia. Możesz bezpiecznie opuścić stronę i kontynuować później.',
  'sale.drafts': 'Szkice',
  'sale.draftsTitle': 'Rozpoczęte sprzedaże, których jeszcze nie utworzyłeś',
  'sale.noDrafts': 'Brak szkiców',
  'sale.searchDrafts': 'Szukaj w szkicach...',
  'sale.deleteDraft': 'Usuń szkic',
  'sale.deleteDraftTitle': 'Usunąć szkic?',
  'sale.deleteDraftBody': 'Czy na pewno chcesz usunąć szkic dla {customer}? Tej operacji nie można cofnąć.',
  'sale.det.help': 'Daty, odniesienia i komentarz do dokumentu. Data faktury i termin płatności określają, kiedy należność obowiązuje i staje się wymagalna. „Nasze odniesienie” to osoba prowadząca sprawę po Twojej stronie, „Wasze odniesienie” to projekt lub osoba kontaktowa klienta. Dla faktur możesz też włączyć cykliczność, aby faktura była wysyłana automatycznie w każdym okresie.',
  'sale.det.date': 'Data',
  'sale.det.due': 'Termin',
  'sale.det.ourRef': 'Nasza referencja',
  'sale.det.ourRefPh': 'Np. osoba prowadząca sprawę u nas',
  'sale.det.theirRef': 'Wasza referencja',
  'sale.det.theirRefPh': 'Wasza referencja / projekt',
  'sale.det.payTo': 'Zapłać na',
  'sale.det.payToHelp': 'Konto bankowe, na które klient ma zapłacić fakturę. Lista pokazuje zapisane konta bankowe — konto do faktur z ustawień jest wybrane domyślnie, a nowe konto możesz dodać bezpośrednio tutaj.',
  'sale.det.payToDefault': 'Konto do faktur',
  'sale.det.payToEmpty': 'Brak zapisanego konta bankowego',
  'sale.det.payToAdd': '+ Dodaj konto bankowe ...',
  'sale.det.comment': 'Komentarz',
  'sale.det.commentPh': 'Opcjonalny komentarz widoczny na dokumencie',
  'sale.det.savedComments': 'Zapisane komentarze',
  'sale.det.saveComment': 'Zapisz komentarz',
  'sale.det.useComment': 'Użyj komentarza',
  'sale.det.noSavedComments': 'Brak zapisanych komentarzy.',
  'sale.det.deliveryFrom': 'Okres dostawy/wykonania - Od',
  'sale.det.deliveryTo': 'Okres dostawy/wykonania - Do',
  'sale.det.repeating': 'Cykliczna',
  'sale.det.repeatingHelpTitle': 'Faktura cykliczna',
  'sale.det.repeatingHelp': 'Włącz, aby faktura była wysyłana automatycznie w regularnych odstępach — np. co miesiąc przy subskrypcji. Wybierasz interwał i termin płatności, a Plumme tworzy i wysyła nową fakturę w każdym okresie bez Twojego udziału.',
  'sale.det.sentEvery': 'Wysyłana co',
  'sale.period.week': 'Tydzień',
  'sale.period.month': 'Miesiąc',
  'sale.period.quarter': 'Kwartał',
  'sale.period.year': 'Rocznie',
  'sale.det.sameDay': 'Tego samego dnia',
  'sale.lines.help': 'Towary i usługi w sprzedaży. Każda linia ma ilość, cenę, stawkę VAT i ewentualny rabat, a suma linii jest obliczana automatycznie. Wybierz zapisany produkt lub wpisz dowolny tekst, a uchwytem po lewej zmień kolejność.',
  'sale.lines.add': 'Dodaj linię',
  'sale.lines.product': 'Produkt',
  'sale.lines.productPh': 'Wyszukaj lub wpisz nowy produkt...',
  'sale.lines.noProductMatch': 'Brak pasujących zapisanych produktów',
  'sale.lines.editProduct': 'Edytuj produkt',
  'sale.lines.productName': 'Nazwa produktu',
  'sale.lines.description': 'Opis',
  'sale.lines.descriptionPh': 'Opcjonalny opis produktu/linii',
  'sale.lines.qty': 'Ilość',
  'sale.lines.vat': 'VAT',
  'sale.lines.discount': 'Rabat',
  'sale.lines.netSum': 'Suma linii netto',
  'sale.lines.toggleVat': 'Przełącz między netto a brutto',
  'sale.lines.more': 'Więcej',
  'sale.lines.less': 'Mniej',
  'sale.lines.searchAccount': 'Szukaj konta...',
  'sale.lines.noAccountMatch': 'Brak kont pasujących do wyszukiwania.',
  'sale.lines.pickAccount': 'Wybierz konto',
  'sale.lines.searchProductPh': 'Szukaj po nazwie lub opisie...',
  'sale.sum.help': 'Suma całej sprzedaży: kwota netto plus VAT daje kwotę, którą zapłaci klient. Liczby aktualizują się automatycznie, gdy zmieniasz linie.',
  'sale.att.title': 'Załączniki',
  'sale.att.upload': 'Prześlij załącznik',
  'sale.att.drop': 'Przeciągnij pliki tutaj',
  'sale.att.dropHint': 'Obrazy lub PDF albo wklej',
  'sale.att.pickFile': 'Wybierz plik',
  'sale.att.dropToAdd': 'Upuść załącznik, aby go dodać',
  'sale.att.dragTip': 'Wskazówka: pliki możesz też przeciągnąć bezpośrednio na stronę.',
  'sale.att.forgot': 'Zapomniałeś o dokumencie? Upuść go tutaj',
  'sale.att.fromInbox': 'Pobierz ze skrzynki odbiorczej',
  'sale.att.uploadInstead': 'Zamiast tego prześlij dokument',
  'sale.att.view': 'Zobacz dokument',
  'sale.att.openPreview': 'Otwórz w podglądzie',
  'sale.send.title': 'Wysyłanie dokumentu',
  'sale.send.to': 'Wyślij do',
  'sale.send.replyTo': 'Odpowiedź do',
  'sale.send.asPdf': 'Wyślij jako załącznik PDF',
  'sale.send.asLink': 'Wyślij jako link',
  'sale.send.pdfHint': 'Klient otrzyma dokument bezpośrednio w e-mailu.',
  'sale.send.linkHint': 'Daje status odczytu, gdy klient otworzy dokument.',
  'sale.send.how': 'Jak wysłać dokument?',
  'sale.send.newRecipient': 'Nowy adres e-mail …',
  'sale.send.saveContact': 'Zapisz jako osobę kontaktową: {customer}',
  'sale.send.thisCustomer': 'klient',
  'sale.send.contactName': 'Imię i nazwisko',
  'sale.send.contactNamePh': 'Jan Kowalski',
  'sale.send.contactRole': 'Rola',
  'sale.send.contactRolePh': 'Księgowość',
  'sale.send.contactSaveFailed': 'Dokument został wysłany, ale nie udało się zapisać osoby kontaktowej.',
  'sale.send.emailPh': 'name@example.com',
  'sale.send.viewDocument': 'Zobacz dokument',
  'sale.preview.sender': 'Nadawca:',
  'sale.preview.invoiceNo': 'Nr faktury:',
  'sale.preview.invoiceDate': 'Data faktury:',
  'sale.preview.dueDate': 'Termin płatności:',
  'sale.preview.ourRef': 'Nasza referencja:',
  'sale.preview.theirRef': 'Wasza referencja:',
  'sale.preview.comment': 'Komentarz:',
  'sale.preview.accountNo': 'Nr konta:',
  'sale.preview.toPay': 'Do zapłaty:',
  'sale.preview.net': 'Netto',
  'sale.preview.vat': 'VAT',
  'sale.preview.paid': 'Zapłacono',
  'sale.preview.toPayShort': 'Do zapłaty',
  'sale.preview.receipt': 'Paragon',
  'sale.preview.paymentHint': 'Prosimy o podanie numeru faktury przy płatności',
  'sale.preview.currencyNote': 'Wszystkie kwoty podano w {currency}',
  'sale.lines.fromDraftDescr': 'Przeniesione ze szkicu',
  'sale.att.maxSize': 'Załączniki mogą mieć maksymalnie {max}.',
  'sale.att.addedOne': 'Dodano 1 załącznik',
  'sale.att.addedMany': 'Dodane załączniki: {count}',
  'sale.comment.deleted': 'Komentarz usunięty',
  'sale.comment.deleteFailed': 'Nie udało się usunąć komentarza.',
  'sale.comment.writeFirst': 'Najpierw napisz komentarz',
  'sale.comment.updated': 'Komentarz zaktualizowany',
  'sale.comment.saveFailed': 'Nie udało się zapisać komentarza.',
  'sale.comment.alreadySaved': 'Komentarz jest już zapisany',
  'sale.comment.saved': 'Komentarz zapisany',
  'sale.comment.backendUnavailable': 'Komentarze nie są połączone z backendem.',
  'sale.det.offerDate': 'Data oferty',
  'sale.det.orderDate': 'Data zamówienia',
  'sale.det.saleDate': 'Data sprzedaży',
  'sale.det.invoiceDateLabel': 'Data faktury',
  'sale.det.validUntil': 'Ważna do',
  'sale.det.dueDateLabel': 'Termin płatności',
  'sale.textLine.titleUpdate': 'Zaktualizuj linię tekstu',
  'sale.textLine.titleNewHeading': 'Nowy nagłówek',
  'sale.textLine.titleNewText': 'Nowa linia tekstu',
  'sale.textLine.update': 'Zaktualizuj',
  'sale.textLine.typeLabel': 'Typ',
  'sale.textLine.typeText': 'Linia tekstu',
  'sale.textLine.typeHeading': 'Nagłówek',
  'sale.textLine.nameLabel': 'Nazwa',
  'sale.textLine.namePhHeading': 'Np. Praca',
  'sale.textLine.namePhText': 'Np. Produkt X',
  'sale.textLine.textLabel': 'Tekst',
  'sale.textLine.textPh': 'Opcjonalny tekst widoczny pod linią',
  'sale.textLine.styleFor': 'Styl dla: {target}',
  'sale.textLine.boldShort': 'B',
  'sale.textLine.italicShort': 'I',
  'sale.textLine.useDivider': 'Użyj linii oddzielającej',
  'sale.textLine.dividerHint': 'Pokaż linię pod tekstem w dokumencie.',
  'sale.textLine.searchPhHeading': 'Wyszukaj lub wpisz nagłówek...',
  'sale.textLine.searchPhText': 'Wyszukaj lub wpisz linię tekstu...',
  'sale.textLine.noMatch': 'Brak pasujących zapisanych linii tekstu',
  'sale.textLine.addAsHeading': 'Dodaj „{value}” jako nowy nagłówek',
  'sale.textLine.addAsText': 'Dodaj „{value}” jako nową linię tekstu',
  'sale.textLine.headingSaved': 'Nagłówek zapisany',
  'sale.textLine.textSaved': 'Linia tekstu zapisana',
  'sale.textLine.headingAdded': 'Nagłówek dodany',
  'sale.textLine.textAdded': 'Linia tekstu dodana',
  'sale.textLine.saveFailed': 'Nie udało się zapisać linii tekstu.',
  'sale.det.durationMonth1': '1 miesiąc',
  'sale.det.durationMonth3': '3 miesiące',
  'sale.det.durationMonth6': '6 miesięcy',
  'sale.det.durationMonth12': '12 miesięcy',
  'sale.lines.typeProduct': 'Linia produktu',
  'sale.lines.typeSpacer': 'Odstęp',
  'sale.lines.noText': 'Bez tekstu',
  'sale.lines.qtyUnit': '{qty} szt.',
  'sale.preview.receiptNoLabel': 'Nr paragonu:',
  'sale.preview.quoteNoLabel': 'Nr oferty:',
  'sale.preview.orderNoLabel': 'Nr zamówienia:',
  'sale.preview.backToOther': 'Wróć do Innej sprzedaży',
  'sale.preview.backToInvoice': 'Wróć do faktury',
  'sale.preview.vatMoms': 'VAT',
  'sale.preview.continuesNextPage': 'Ciąg dalszy na następnej stronie',
  'sale.att.labelWithName': 'Załącznik · {name}',
  'sale.att.dropHere': 'Upuść dokument tutaj',
  'sale.att.otherSaleHint': 'Inna sprzedaż to ogólna sprzedaż poza systemem - prześlij zdjęcie lub PDF jako dokumentację.',
  'sale.att.previewHint': 'Aby wyświetlić podgląd, kliknij jeden z załączników lub „Zobacz paragon”.',
  'sale.att.viewReceipt': 'Zobacz paragon',
  'sale.att.createReceipt': 'Utwórz paragon',
  'sale.mode.subtitle': 'Wybierz spokojny proces krok po kroku lub zachowaj wszystkie pola na jednej stronie.',
  'sale.mode.stepsDesc': 'Klient, szczegóły, linie i podgląd - jedno po drugim. Dobre na początek.',
  'sale.mode.onePageDesc': 'Cała faktura w jednym miejscu z podglądem na żywo. Szybko dla doświadczonych.',
  'sale.draft.noCustomer': 'Bez klienta',
  'sale.draft.noMatchesTitle': 'Brak wyników',
  'sale.draft.noMatchesText': 'Brak szkiców pasujących do wyszukiwania.',
  'sale.draft.emptyText': 'Rozpoczęte sprzedaże są zapisywane tutaj, gdy klikniesz „Zapisz szkic”.',
  'sale.draft.colSale': 'Sprzedaż',
  'sale.draft.noNumber': 'Bez numeru',
  'sale.draft.colDate': 'Data',
  'sale.draft.colAmount': 'Kwota',
  'sale.draft.deleteFailed': 'Nie udało się usunąć szkicu.',
  'sale.draft.saveFailed': 'Nie udało się zapisać szkicu.',
  'sale.draft.deleteUnavailable': 'Usuwanie szkiców nie jest połączone z backendem.',
  'sale.draft.onlyDraftsDelete': 'Tutaj można usuwać tylko szkice',
  'sale.draft.deleted': 'Szkic usunięty',
  'sale.draft.saveUnavailable': 'Zapisywanie szkiców nie jest połączone z backendem.',
  'sale.draft.savedToList': 'Szkic został zapisany na liście faktur',
  'sale.create.invoice': 'Utwórz fakturę',
  'sale.create.quote': 'Utwórz ofertę',
  'sale.create.order': 'Utwórz potwierdzenie zamówienia',
  'sale.create.other': 'Zarejestruj sprzedaż',
  'sale.create.needMatchingPartials': 'Najpierw suma rat musi zgadzać się z sumą sprzedaży',
  'sale.create.needLineOrAttachment': 'Najpierw dodaj linię lub dokument',
  'sale.create.needCustomerAndProduct': 'Najpierw wybierz klienta i dodaj co najmniej jeden produkt',
  'sale.create.needCustomer': 'Najpierw wybierz klienta',
  'sale.create.needProduct': 'Najpierw dodaj co najmniej jeden produkt',
  'sale.create.receiptSendingBackground': 'Paragon jest wysyłany w tle',
  'sale.create.receiptSentEmail': 'Paragon został wysłany e-mailem.',
  'sale.create.recurringSaveFailed': 'Faktura została utworzona, ale nie udało się zapisać umowy cyklicznej.',
  'sale.create.createFailed': 'Nie udało się utworzyć sprzedaży.',
  'sale.create.createdTitle': 'Utworzono: {doc} {num}.',
  'sale.create.saleCreatedBody': 'Sprzedaż została zaksięgowana. Możesz zapisać paragon, wysłać dokumentację klientowi lub zamknąć.',
  'sale.create.docCreatedBody': 'Możesz zapisać {def} jako PDF lub przesłać {pron} dalej e-mailem.',
  'sale.create.pdfReceiptLabel': 'PDF/Paragon',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'Wysyłanie nie jest dostępne dla tej sprzedaży.',
  'sale.send.unavailableDocument': 'Wysyłanie nie jest dostępne dla tego dokumentu.',
  'sale.send.failed': 'Wysyłanie nie powiodło się.',
  'sale.send.customerFallback': 'Klient',
  'sale.send.defaultContactRole': 'Kontakt domyślny',
  'sale.send.contactFallback': 'Osoba kontaktowa',
  'sale.send.recipientFallback': 'Odbiorca',
  'sale.send.receiptTitle': 'Wyślij paragon',
  'sale.send.howToSend': 'Jak chcesz wysłać: {doc}?',
  'sale.send.receiptEmailHint': 'Wprowadź adres e-mail, na który ma zostać wysłany paragon.',
  'sale.send.chooseDeliveryHint': 'Wybierz, czy klient otrzyma PDF w e-mailu, czy link, który Postplumma może śledzić.',
  'sale.send.allCustomersInList': 'Wszyscy klienci na liście ({count})',
  'sale.send.needEmailFirst': 'Przed wysłaniem wprowadź e-mail klienta lub osoby kontaktowej.',
  'sale.send.stepDraftPrep': 'Przygotowywanie szkicu',
  'sale.send.stepArriving': 'Postplumma nadchodzi',
  'sale.send.stepSuccess': 'Sukces! Postplumma jest w drodze.',
  'sale.send.receiptReadyNoEmail': 'Paragon jest gotowy, ale nie wysłano żadnego e-maila.',
  'sale.send.sendingInBackground': '{doc} – wysyłanie w tle',
  'sale.send.sentAsLinkShort': '{doc} – wysłano jako link.',
  'sale.send.sentAsLinkTracked': '{doc} – wysłano jako link. Status odczytu możesz śledzić na liście faktur.',
  'sale.send.sentAsEmail': '{doc} – wysłano e-mailem.',
  'sale.send.readyNoEmail': '{doc} – gotowe, ale nie wysłano żadnego e-maila.',
  'sale.send.sentToRecipients': 'Wysłano do odbiorców: {count}.',
  'sale.send.notProvided': 'Nie podano',
  'sale.send.spamTip': 'Wskazówka: jeśli klient nie może znaleźć e-maila, poproś go o sprawdzenie folderu spam.',
  'sale.inboxPicker.tabInbox': 'Skrzynka odbiorcza ({count})',
  'sale.inboxPicker.tabDocumentation': 'Dokumentacja ({count})',
  'sale.inboxPicker.searchDocumentation': 'Szukaj w dokumentacji',
  'sale.inboxPicker.searchInbox': 'Szukaj w skrzynce odbiorczej',
  'sale.inboxPicker.selectTip': 'Wskazówka: przytrzymaj Shift, aby zaznaczyć kilka kolejnych, lub Ctrl/Cmd, aby zaznaczać pojedynczo.',
  'sale.inboxPicker.emptyDocumentation': 'Żaden dokument nie pasuje do wyszukiwania.',
  'sale.inboxPicker.emptyInbox': 'Żaden dokument w skrzynce odbiorczej nie pasuje do wyszukiwania.',
  'sale.inboxPicker.fallbackReceipt': 'Dokument księgowy',
  'sale.inboxPicker.fallbackDocument': 'Dokument',
  'sale.inboxPicker.fallbackDocumentation': 'Dokumentacja',
  'sale.lines.subscriptionPeriod': 'Subskrypcja - {{period}}',
  'sale.lines.months12': '12 mies.',
  'sale.lines.month1': '1 mies.',
  'sale.lines.rentalPrice': 'Wynajem - {{price}}',
  'sale.lines.addAsNewProduct': 'Dodaj „{{value}}” jako nowy produkt',
  'sale.lines.useDivider': 'Użyj linii podziału',
  'sale.lines.dividerHint': 'Wyświetla linię pod tym wierszem w dokumencie.',
  'sale.preview.colDescription': 'Opis',
  'sale.preview.colQty': 'Ilość',
  'sale.preview.colPrice': 'Cena',
  'sale.preview.colDiscount': 'Rabat',
  'sale.preview.colSum': 'Suma',
  'sale.doc.invoiceName': 'Faktura',
  'sale.doc.quoteName': 'Oferta',
  'sale.doc.orderConfirmationName': 'Potwierdzenie zamówienia',
  'sale.doc.creditNoteName': 'Faktura korygująca',
  'sale.draft.colType': 'Typ',
  'sale.period.every14days': 'Co 14 dni',
  'sale.det.dueDays': 'Dni: {{count}}',
  'sale.lines.priceExVat': 'Cena bez VAT',
  'sale.lines.priceIncVat': 'Cena z VAT',
  'sale.lines.lineNumber': 'Wiersz {{n}}',
  'sale.lines.pickProduct': 'Wybierz produkt',
  'sale.lines.freeText': 'Dowolny tekst',
  'sale.lines.spacerHint': 'Pusty wiersz jest wyświetlany w dokumencie jako odstęp.',
  'sale.lines.chooseLineType': 'Wybierz typ wiersza',
  'agreements.notSent': 'Nie wysłano',
  'agreements.error.missingCustomerEmail': 'Klient nie ma adresu e-mail. Dodaj e-mail klienta, a faktura zostanie wysłana przy następnym uruchomieniu.',
  'agreements.error.missingCustomer': 'Klient już nie istnieje lub został zarchiwizowany. Wybierz aktywnego klienta dla umowy.',
  'agreements.warning.missingCustomerEmail': 'Klient nie ma adresu e-mail',
  'agreements.warning.missingCustomerEmailHelp': 'Automatyczna wysyłka wymaga adresu e-mail. Dodaj go do klienta przed następną datą fakturowania, w przeciwnym razie faktura nie zostanie wysłana.',
});
